import axios from "../config/axios.v2";
import { BLOG_URL, blogByIdUrl, blogBySlugUrl } from "./blog.url.service";

const unwrap = (res) => res.data?.data ?? res.data;
const unwrapList = (res) => ({
  data: res.data?.datas || res.data,
  pagination: res.data?.pagination ?? {}
});

const handleError = (err) => {
  console.log("blogService err::", err);
  throw err;
};

const BlogService = {
  getAll: (params) => axios.get(BLOG_URL, { params }).then(unwrapList).catch(handleError),
  getById: (id) => axios.get(blogByIdUrl(id)).then(unwrap).catch(handleError),
  getBySlug: (slug) => axios.get(blogBySlugUrl(slug)).then(unwrap).catch(handleError),
  create: (payload) => axios.post(BLOG_URL, payload).then(unwrap).catch(handleError),
  update: (id, payload) => axios.patch(blogByIdUrl(id), payload).then(unwrap).catch(handleError),
  remove: (id) => axios.delete(blogByIdUrl(id)).then(unwrap).catch(handleError)
};

export default BlogService;
